const { Autocomplete, TextField } = require("@mui/material");

function SearchFilter({
  all,
  value,
  setValue,
  options,
  removeUnderscore,
  disabled,
  labelSelect,
}) {
  let allOptions = [];

  if (removeUnderscore) {
    if (all) {
      allOptions = [
        { label: labelSelect ? "Select" : "All", value: "All" },
        ...options.map((item) => ({
          label: item ? item.replaceAll("_", " ") : "Null",
          value: item,
        })),
      ];
    } else {
      allOptions = options.map((item) => ({
        label: item ? item.replaceAll("_", " ") : "Null",
        value: item,
      }));
    }
  } else {
    allOptions = all ? [labelSelect ? "Select" : "All", ...options] : options;
  }

  return (
    <Autocomplete
      disabled={disabled}
      disableClearable
      options={allOptions}
      value={value === "All" ? (labelSelect ? "Select" : "All") : value}
      onChange={(_, v) =>
        removeUnderscore
          ? setValue(v.value)
          : setValue(v === "Select" ? "All" : v)
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          sx={{
            "& .MuiOutlinedInput-root": {
              height: 28,
              fontSize: 12,
            },
          }}
        />
      )}
    />
  );
}

export default SearchFilter;
